module.exports = __webpack_public_path__ + "static/media/books.5fbf51dc.svg";